import apiClient from "../api/api";
import { API_ENDPOINTS } from "../api/api.config";

export interface IApiEndpoint {
  _id: string;
  api_name: string;
  endpoint: string;
  method: "GET" | "POST" | "PUT" | "DELETE";
  api_key?: string;
  headers?: Record<string, string>;
  rate_limit: number;
  createdAt: string;
  updatedAt: string;
  is_active: boolean;
  is_deleted: boolean;
  __v: number;
  description?: string;
}

export interface ApiEndpointListParams {
  skip?: number;
  limit?: number;
  api_name?: string;
}

export interface ApiEndpointStats {
  total_endpoints: number;
  active_endpoints: number;
  inactive_endpoints: number;
}

export interface CreateApiEndpointData {
  api_name: string;
  endpoint: string;
  method: "GET" | "POST" | "PUT" | "DELETE";
  api_key?: string;
  headers?: Record<string, string>;
  rate_limit: number;
  description?: string;
}

export interface UpdateApiEndpointData {
  api_name?: string;
  endpoint?: string;
  method?: "GET" | "POST" | "PUT" | "DELETE";
  api_key?: string;
  headers?: Record<string, string>;
  rate_limit?: number;
  description?: string;
}

export interface ApiConfigListResponse {
  success: boolean;
  code: number;
  data: {
    configs: IApiEndpoint[];
    total_count: number;
  };
}

export interface ApiEndpointStatsResponse {
  success: boolean;
  code: number;
  data: ApiEndpointStats;
}

const apiEndpointService = {
  getApiEndpoints: async (data?: ApiEndpointListParams) => {
    const response = await apiClient.post<ApiConfigListResponse>(
      API_ENDPOINTS.API_ENDPOINTS.LIST,
      data
    );
    return response.data;
  },

  getApiEndpointById: async (id: string) => {
    const response = await apiClient.get<IApiEndpoint>(
      API_ENDPOINTS.API_ENDPOINTS.GET_BY_ID(id)
    );
    return response.data;
  },

  createApiEndpoint: async (data: CreateApiEndpointData) => {
    const response = await apiClient.post<IApiEndpoint>(
      API_ENDPOINTS.API_ENDPOINTS.CREATE,
      data
    );
    return response.data;
  },

  updateApiEndpoint: async (id: string, data: UpdateApiEndpointData) => {
    const response = await apiClient.put<IApiEndpoint>(
      `${API_ENDPOINTS.API_ENDPOINTS.UPDATE}/${id}`,
      data
    );
    return response.data;
  },

  deleteApiEndpoint: async (id: string) => {
    const response = await apiClient.delete<{ message: string }>(
      API_ENDPOINTS.API_ENDPOINTS.DELETE(id)
    );
    return response.data;
  },

  getApiEndpointStats: async () => {
    const response = await apiClient.get<ApiEndpointStatsResponse>(
      API_ENDPOINTS.API_ENDPOINTS.STATS
    );
    return response.data;
  },
};

export default apiEndpointService;
